"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var step_1 = require("../step");
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var FormToCreate_1 = require("../../../Client/Application/Common/FormToCreate/FormToCreate");
var FormToCreateStore_1 = __importDefault(require("../../../Client/Application/Common/FormToCreate/FormToCreateStore"));
var c = (0, BemBuilder_1.default)("create-page-flow-token-form");
var TokenForm = (function (_super) {
    __extends(TokenForm, _super);
    function TokenForm(props) {
        var _this = _super.call(this, props) || this;
        _this.formFields = [];
        _this.createFormFields = function (tokenList) {
            if (!tokenList) {
                throw new Error("Tokens are required");
            }
            return tokenList.map(function (token) { return (0, FormToCreate_1.createFormField)(token.name, token.apiName); });
        };
        _this.onSubmit = function () { return __awaiter(_this, void 0, Promise, function () {
            var substitutions;
            var _this = this;
            return __generator(this, function (_a) {
                substitutions = {};
                this.formFields.map(function (formField) {
                    substitutions[formField.id] = _this.formStore.getById(formField.id);
                });
                this.props.store.setSubstitutions(substitutions);
                this.props.moveStep(1);
                return [2];
            });
        }); };
        _this.formStore = new FormToCreateStore_1.default();
        _this.formFields = _this.createFormFields(_this.props.store.tokenList);
        return _this;
    }
    TokenForm.prototype.render = function () {
        return (react_1.default.createElement("div", { className: c() },
            react_1.default.createElement(kaleidoscope_1.Heading, { className: c("heading"), level: "3" }, "Create Page with Tokens"),
            react_1.default.createElement("div", { className: c("description") },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(kaleidoscope_1.Text, null, "Fill in the tokens below to personalise your Qwilr Page. If you leave a token blank, you can always add that information to the page later."))),
            react_1.default.createElement(kaleidoscope_1.Form, { className: c("form"), width: kaleidoscope_1.FormWidth.Wide, dataStore: this.formStore, fields: this.formFields, onComplete: function () { return Promise.resolve(); }, hideSubmitButton: true, inputSize: kaleidoscope_1.FormInputSize.Large }),
            react_1.default.createElement(kaleidoscope_1.Button, { className: c("button"), type: kaleidoscope_1.ButtonType.Primary, onClick: this.onSubmit }, "Next")));
    };
    var _a;
    TokenForm = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [typeof (_a = typeof step_1.StepProps !== "undefined" && step_1.StepProps) === "function" ? _a : Object])
    ], TokenForm);
    return TokenForm;
}(react_1.default.Component));
exports.default = TokenForm;
